import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from "@angular/router";
import { AuthGuardGuard } from "src/app/core/guards/auth-guard.guard";
import { RoleLandingGuardGuard } from "src/app/core/guards/role-landing-guard.guard";
import { IndexComponent } from "./pages/index/index.component";
import { SharedModule } from "src/app/shared/shared.module";
import { AdminHomeComponent } from './pages/admin/admin.component';
import { AdminRoleGuard } from '../../core/guards/admin-role.guard';
import { GuestRoleGuard } from '../../core/guards/guest-role.guard';
import { GuestHomeComponent } from './pages/guest/guest.component';
import { CommonUserHomeComponent } from './pages/common-user/common-user.component';

const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    canActivate: [AuthGuardGuard, RoleLandingGuardGuard],
  },
  {
    path: "",
    component: IndexComponent,
    children: [
      {
        path: "admin",
        component: AdminHomeComponent,
        canActivate: [AdminRoleGuard],
        children: [
          {
            path: "",
            redirectTo: 'organizations',
            pathMatch: 'full',
            loadChildren: () =>
              import(
                "../organizations/organizations.module"
              ).then((m) => m.OrganizationsModule),
          },
          {
            path: "organizations",
            loadChildren: () =>
              import(
                "../organizations/organizations.module"
              ).then((m) => m.OrganizationsModule),
          },
          {
            path: "users",
            loadChildren: () =>
              import("../users/users.module").then(
                (m) => m.UsersModule
              ),
          },
          {
            path: "documents",
            loadChildren: () =>
              import(
                "../documents-grid/documents-grid.module"
              ).then((m) => m.DocumentsGridModule),
          },
          {
            path: "verification",
            loadChildren: () =>
              import(
                "../verification/verification.module"
              ).then((m) => m.VerificationModule),
          },
          {
            path: "patients",
            loadChildren: () =>
              import("../users/users.module").then(
                (m) => m.UsersModule
              ),
          },
          {
            path: "user-management",
            loadChildren: () =>
              import("../user-management/user-management.module").then(
                (m) => m.UserManagementModule
              ),
          },
          {
            path: "alert-config",
            loadChildren: () =>
              import("../alert-config/alert-config.module").then(
                (m) => m.AlertConfigModule
              ),
          },
          {
            path: "pending-signatures-panel",
            loadChildren: () =>
              import("../pending-signatures-panel/pending-signatures-panel.module").then(
                (m) => m.PendingSignaturesPanelModule
              ),
          }
        ],
      },
      {
        path: "guest",
        component: GuestHomeComponent,
        canActivate: [GuestRoleGuard],
        children: [
          {
            path: "",
            redirectTo: 'users',
            pathMatch: 'full',
            loadChildren: () =>
              import(
                "../users/users.module"
              ).then((m) => m.UsersModule),
          },
          {
            path: "users",
            loadChildren: () =>
              import("../users/users.module").then(
                (m) => m.UsersModule
              ),
          },
          {
            path: "documents",
            loadChildren: () =>
              import(
                "../documents-grid/documents-grid.module"
              ).then((m) => m.DocumentsGridModule),
          },
          {
            path: "verification",
            loadChildren: () =>
              import(
                "../verification/verification.module"
              ).then((m) => m.VerificationModule),
          }
        ],
      },
     
    ],
  },
];

@NgModule({

  imports: [
    RouterModule.forChild(routes), 
    SharedModule,
    CommonModule
  ],
  exports: [],
  declarations: [
    AdminHomeComponent,
    GuestHomeComponent,
    CommonUserHomeComponent
  ],
})
export class LandingPageRoutingModule { }
